import { useReactQuery } from "hooks/use-react-query";

export function useListVideos({ payload, skip }) {
  const {
    data,
    isLoading,
    error,
    inValidateQuery,
    refetch: refetchVideos,
  } = useReactQuery({
    url: "/get_user_history_by_date",
    isAbsoluteUrl: true,
    method: "POST",
    paramsData: payload,
    queryKey: [
      "videosList",
      ...Object.entries(payload).map(([key, val]) => `${key}:${val}`),
    ],
    skip: skip || !payload,
  });

  return {
    data,
    isLoading: isLoading,
    error,
    inValidateQuery,
    refetchVideos,
  };
}
